/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Csv_To_Json_Ref_N6Inputs */

const en_csv_to_json_ref_n6 = /** @type {(inputs: Csv_To_Json_Ref_N6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A record shorter than the header gets empty strings for the missing fields.`)
};

const ko_csv_to_json_ref_n6 = /** @type {(inputs: Csv_To_Json_Ref_N6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`헤더보다 짧은 레코드는 없는 필드에 빈 문자열을 받습니다.`)
};

const ja_csv_to_json_ref_n6 = /** @type {(inputs: Csv_To_Json_Ref_N6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ヘッダより短いレコードは、欠けたフィールドに空文字列を受け取ります。`)
};

/**
* | output |
* | --- |
* | "A record shorter than the header gets empty strings for the missing fields." |
*
* @param {Csv_To_Json_Ref_N6Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const csv_to_json_ref_n6 = /** @type {((inputs?: Csv_To_Json_Ref_N6Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Csv_To_Json_Ref_N6Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_csv_to_json_ref_n6(inputs)
	if (locale === "ko") return ko_csv_to_json_ref_n6(inputs)
	return ja_csv_to_json_ref_n6(inputs)
});